<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>상담 & 문의</h1>
    </div>
    <router-view name="listPage"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {},
}
</script>

<style></style>
